import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from '../../../../../../components/Common/UI/Input';
import Separator from '../../../../../../components/Common/UI/Separator';
import { Button } from '../../../../../../components/Common/UI/Button';
import Icons from '../../../../../../components/Common/Icons/Icons';
import { IAccountManagementCreateUser, InvalidFields } from '../index';

interface ICreateUserForm {
  state: IAccountManagementCreateUser;
  invalidFields: InvalidFields;
  handleInputChange: (key: keyof IAccountManagementCreateUser, value: string) => void;
  handleValidate: (key: keyof IAccountManagementCreateUser, value: string) => void;
  handleReset: () => void;
  handleSubmit: () => void;
}

function CreateUserForm({
  handleSubmit,
  handleReset,
  handleValidate,
  invalidFields,
  state,
  handleInputChange,
}: ICreateUserForm) {
  const navigate = useNavigate();

  return (
    <>
      <div className="grid gap-[20px]">
        <Input
          placeholder="Enter Primary External User ID"
          label="Primary External User ID*"
          error={invalidFields.primaryUserId ? 'Primary External User ID Cannot Be Blank' : null}
          onChange={e => handleInputChange('primaryUserId', e.target.value)}
          onBlur={e => handleValidate('primaryUserId', e.target.value)}
          value={state?.primaryUserId}
          maxLength={75}
        />
        <Input
          placeholder="Enter Secondary External User ID"
          label="Secondary External User ID"
          onChange={e => handleInputChange('secondaryUserId', e.target.value)}
          value={state?.secondaryUserId}
          maxLength={75}
        />
        <Input
          placeholder="Enter First Name"
          label="First Name*"
          error={invalidFields.firstName ? 'First Name Cannot Be Blank' : null}
          onChange={e => handleInputChange('firstName', e.target.value)}
          onBlur={e => handleValidate('firstName', e.target.value)}
          value={state?.firstName}
          maxLength={75}
        />
        <Input
          placeholder="Enter Last Name"
          label="Last Name*"
          error={invalidFields.lastName ? 'Last Name Cannot Be Blank' : null}
          onChange={e => handleInputChange('lastName', e.target.value)}
          onBlur={e => handleValidate('lastName', e.target.value)}
          value={state?.lastName}
          maxLength={75}
        />
        <Input
          placeholder="Type"
          label="Type"
          onChange={e => handleInputChange('type', e.target.value)}
          value={state?.type}
          maxLength={75}
        />
      </div>
      <Separator className="mt-[20px]" />
      <div className="flex justify-between items-center gap-[20px] py-[10px]">
        <Button
          variant="link"
          onClick={() => navigate('/infoTrac/account-management')}
          className="flex gap-[10px] items-center px-0"
        >
          <Icons.ArrowRight className="rotate-180" />
          Back
        </Button>
        <div className="flex gap-[20px] items-center">
          <Button variant="secondary" onClick={handleReset}>
            Reset
          </Button>
          <Button onClick={handleSubmit} className="flex gap-[10px] items-center">
            <Icons.SaveFilled className="opacity-60 w-[20px] h-[20px]" />
            Save
          </Button>
        </div>
      </div>
    </>
  );
}

export default CreateUserForm;
